// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { GetConfigData, GetConfigResponses, GetMeData, GetMeResponses, GetMeStateData, GetMeStateResponses, GetMeWalletData, GetMeWalletResponses, GetParamByIdsData, GetParamByIdsResponses, GetRewardsRecentWinnersData, GetRewardsRecentWinnersResponses, PostMeOpenMilestonesByMilestoneIdData, PostMeOpenMilestonesByMilestoneIdResponses, PostTimesyncData, PostTimesyncResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Common params
 */
export const getParamByIds = <ThrowOnError extends boolean = false>(options: Options<GetParamByIdsData, ThrowOnError>) => (options.client ?? client).get<GetParamByIdsResponses, unknown, ThrowOnError>({ url: '/param/{ids}', ...options });

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({ url: '/me', ...options });

/**
 * getState
 *
 * Get user current state. Including: owned items, openned milestone, rewards.
 */
export const getMeState = <ThrowOnError extends boolean = false>(options?: Options<GetMeStateData, ThrowOnError>) => (options?.client ?? client).get<GetMeStateResponses, unknown, ThrowOnError>({ url: '/me/state', ...options });

/**
 * getWallet
 *
 * Get the current cached Gem balance.
 */
export const getMeWallet = <ThrowOnError extends boolean = false>(options?: Options<GetMeWalletData, ThrowOnError>) => (options?.client ?? client).get<GetMeWalletResponses, unknown, ThrowOnError>({ url: '/me/wallet', ...options });

/**
 * openMilestone
 *
 * Open the milestone
 */
export const postMeOpenMilestonesByMilestoneId = <ThrowOnError extends boolean = false>(options: Options<PostMeOpenMilestonesByMilestoneIdData, ThrowOnError>) => (options.client ?? client).post<PostMeOpenMilestonesByMilestoneIdResponses, unknown, ThrowOnError>({
    url: '/me/open-milestones/{milestoneId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postTimesync = <ThrowOnError extends boolean = false>(options: Options<PostTimesyncData, ThrowOnError>) => (options.client ?? client).post<PostTimesyncResponses, unknown, ThrowOnError>({
    url: '/timesync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConfig = <ThrowOnError extends boolean = false>(options?: Options<GetConfigData, ThrowOnError>) => (options?.client ?? client).get<GetConfigResponses, unknown, ThrowOnError>({ url: '/config', ...options });

/**
 * getRecentWinners
 *
 * Get the latest grand-prize winners for the event marquee.
 */
export const getRewardsRecentWinners = <ThrowOnError extends boolean = false>(options?: Options<GetRewardsRecentWinnersData, ThrowOnError>) => (options?.client ?? client).get<GetRewardsRecentWinnersResponses, unknown, ThrowOnError>({ url: '/rewards/recent-winners', ...options });
